/**
 * Wire format for the standings page.
 *
 * Teams are identified by `id` — the manager's Sleeper user id — everywhere,
 * never by a name, so a franchise survives a rename and lines up across
 * seasons. See `StatRow` in `stats.ts` for the same rule on the stats page.
 */
/**
 * The things that happen to a team during a season and show up on its line in
 * the standings graph.
 *
 * Deliberately short: these are the moves and the misfortune that explain a
 * climb or a slide, not a full transaction log.
 */
export const STANDINGS_EVENT_TYPES = ['trade', 'waiver', 'injury'];
export const STANDINGS_EVENT_LABELS = {
    trade: 'Trades',
    waiver: 'Waiver pickups',
    injury: 'Injuries',
};
/**
 * Dynasty points for a finishing position: 10 for first down to 1 for last in a
 * ten-team league. Shared so the explainer modal and the server cannot drift.
 */
export function dynastyPointsFor(position, numTeams) {
    return Math.max(numTeams + 1 - position, 0);
}
//# sourceMappingURL=standings.js.map